// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.update-modal[data-v-ac406314] .p-dialog-header {\n  display: none;\n}\n.update-modal[data-v-ac406314] .p-dialog-content {\n  padding: 1.5rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
